export interface Benchmark {
  key?: string;
  accountId?: string;
  accountName?: string;
  isPackaged?: boolean
  packagedCoverageTypes?: string;
  frozen?: boolean;
  accountNameAlt?: string;
  programType?: string;
  policyYear?: number;
  sic: string;
  industry?: string;
  industryId?: number;
  industryName?: string;
  stockTicker: string;
  ownershipType: string;
  policyEffectiveDate?: string;
}

export interface AccountBenchmark {
  accountId: string;
  accountName: string;
  sic?: string;
  stockTicker?: string;
  ownershipType?: string;
  employeeCount?: number;
  annualRevenue?: number;
  planFiduciaryAssets?: number;
}

export interface DOBenchmark extends Benchmark {
  marketCap2YearHigh: number;
  marketCapMostRecent: number;
  revenueTTM: number;
  companyAssets?: number;
  totalRetention?: number;
  totalDOLimit: number;
  totalABCLimit: number;
  totalSideA: number;
  totalPrimaryLimit: number;
  maxPrimaryPPMAnnualized: number;
  firstLayerILF: number;
}

export const emptyBenchmark = {
  key: '',
  accountName: ' ',
  policyYear: ' ' as never,
  programType: '',
  industry: '',
  sic: '',
  stockTicker: '',
  ownershipType: '',
  marketCap2YearHigh: 0,
  marketCapMostRecent: 0,
  revenueTTM: 0,
  companyAssets: 0,
  totalRetention: 0,
  totalDOLimit: 0,
  totalABCLimit: 0,
  totalSideA: 0,
  totalPrimaryLimit: 0,
  maxPrimaryPPMAnnualized: 0,
  firstLayerILF: 0,
  frozen: true,
} as DOBenchmark;

export interface CyberBenchmark extends Benchmark {
  revenueTTM?: number;
  totalRetention?: number;
  totalLimit?: number;
  totalPrimaryLimit?: number;
  maxPrimaryPPM?: number;
  firstLayerILF?: number;
  primaryCarrierGroup?: string;
  primaryCarrierGroupID?: string;
}

export interface FiduciaryBenchmark extends Benchmark {
  planFiduciaryAssets?: number;
  totalRetention?: number;
  totalLimit?: number;
  totalPrimaryLimit?: number;
  maxPrimaryPPM?: number;
  firstLayerILF?: number;
  primaryCarrierGroup?: string;
  primaryCarrierGroupID?: string;
}

export interface EPLBenchmark extends Benchmark {
  employeeCount?: number;
  totalRetention?: number;
  totalLimit?: number;
  totalPrimaryLimit?: number;
  maxPrimaryPPM?: number;
  firstLayerILF?: number;
  primaryCarrierGroup?: string;
  primaryCarrierGroupID?: string;
}

export interface CrimeBenchmark extends Benchmark {
  employeeCount?: number;
  annualRevenue?: number;
  totalRetention?: number;
  totalLimit?: number;
  totalPrimaryLimit?: number;
  maxPrimaryPPM?: number;
  firstLayerILF?: number;
  primaryCarrierGroup?: string;
  primaryCarrierGroupID?: string;
}

export interface UmbrellaCarrierBenchmark {
  genericIndustry: string;
  countOfPrograms: number;
  maxLimit: number;
  medianLimit: number;
  averageLimit: number;
}

export interface UmbrellaTotalLimit {
  limitValue: number;
  countOfResults: number;
}
